import { useMediaQuery } from 'native-base';

export const useBasicInformationFormController = () => {
  const [isMobile] = useMediaQuery({ maxWidth: 600 });

  return { isMobile };
};
